var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"JoszakiCard max-lg:p-3 lg:p-4 rounded-md shadow-md dark:shadow-gray-900/50 border transition-shadow",class:{
    'hover:shadow-xl': _vm.hoverable,
    'bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-600':
      'default' === _vm.type,
    'bg-gray-50 border-gray-300 dark:bg-gray-700 dark:border-gray-600':
      'gray' === _vm.type,
    'bg-info text-white border-info-darker': 'info' === _vm.type,
    'bg-primary text-white border-primary-darker': 'primary' === _vm.type,
    'bg-gradient-to-r from-blue-50 to-blue-100 border-blue-200 dark:from-blue-900 dark:to-blue-800 dark:border-blue-700':
      'primary-alt' === _vm.type,
    'bg-success text-white border-success-darker': 'success' === _vm.type,
    'bg-gradient-to-r from-green-50 to-green-100 border-green-200 dark:from-green-900 dark:to-green-800 dark:border-green-700':
      'success-alt' === _vm.type,
    'bg-warning border-warning-darker': 'warning' === _vm.type,
    'bg-gradient-to-r from-orange-50 to-orange-100 border-orange-200 dark:from-orange-900 dark:to-orange-800 dark:border-orange-700':
      'warning-alt' === _vm.type,
    'bg-danger text-white border-danger-darker': 'danger' === _vm.type,
    'bg-error border-error-darker': 'error' === _vm.type,
    'bg-rating border-rating-darker': 'rating' === _vm.type,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }